import api from "@/store/api";
import { Portfolio } from "@/types";

const emptyState = () => {
	return {
		items: [] as Array<any>,
		availableStrategies: [] as Array<any>,
		banks: [] as Array<any>,
		selected: (null as unknown) as Portfolio,
	}
};

const state = emptyState();
type State = typeof state;

export default {
	namespaced: true,
	state: emptyState(),
	getters: {},
	actions: {
		portfolios(store: any) {
			api
				.get("client-zone-users/strategies")
				.then(({data}) => {
					store.commit("setItems", data.result);
				})
				.catch((error) => {
					store.commit("setItems", []);
				});
		}
	},
	mutations: {
		select(state: State, data: any) {
			state.selected = data;
		},
		setItems(state: State, data: Array<any>) {
			state.items = data;
		},
		reset (state: any) {
			Object.assign(state, emptyState());
			state.selected = null;
		}
	},
};
